// extracted by mini-css-extract-plugin
export default {"root":"CardSkelet_root--I6Y","item":"CardSkelet_item--itb","skeletShimmer":"CardSkelet_skeletShimmer--zD9"};